import React from "react";

// Real Estate Agent Assist store links.
export const REASSIST_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.crossvisiondevstudios.reassist";

// Apple campaign link: App Store Connect lists downloads per ct value under
// App Analytics > Acquisition > Campaigns, with no SDK or cookies. ct is the
// page's utm_campaign (so an ad's landing page credits the ad), else
// "website"; Apple allows letters, digits, - and _, up to 40 characters.
export const reassistAppStoreUrl = () => {
  const campaign = (
    new URLSearchParams(window.location.search).get("utm_campaign") || ""
  )
    .replace(/[^A-Za-z0-9_-]/g, "")
    .slice(0, 40);
  return `https://apps.apple.com/app/apple-store/id6804875489?pt=124999001&ct=${
    campaign || "website"
  }&mt=8`;
};

const appStoreImage = require("../assets/mobile/getappstore.png");
const playStoreImage = require("../assets/mobile/getgoogleplay.png");

// Google's official badge has a transparent margin of 41px around a 646x250
// image, so the visible badge is 168/250 of the image height. Scale it up
// and pull the margin back in so both badges look the same height.
const PLAY_VISIBLE_RATIO = 168 / 250;
const PLAY_MARGIN_RATIO = 41 / 250;

const AppStoreBadges = ({
  height = 48,
  align = "center",
  appStoreUrl = reassistAppStoreUrl(),
  playStoreUrl = REASSIST_PLAY_STORE_URL,
  className,
}) => {
  const playHeight = Math.round(height / PLAY_VISIBLE_RATIO);
  const playMargin = -Math.round(playHeight * PLAY_MARGIN_RATIO);

  return (
    <div
      className={className}
      style={{
        ...styles.row,
        justifyContent: align === "center" ? "center" : "flex-start",
      }}
    >
      {appStoreUrl && (
        <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={appStoreImage}
            style={{ ...styles.badge, height }}
            alt="Download on the App Store"
          />
        </a>
      )}
      {playStoreUrl && (
        <a href={playStoreUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={playStoreImage}
            style={{ ...styles.badge, height: playHeight, margin: playMargin }}
            alt="Get it on Google Play"
          />
        </a>
      )}
    </div>
  );
};

export default AppStoreBadges;

const styles = {
  badge: {
    display: "block",
  },
  row: {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
  },
};
